export default "__VITE_ASSET__4c5024f3__"